import { Subject } from 'rxjs';
import { ToolbarPosition } from '../enums/toolbar-position';
import { TruncationMode } from '../enums/truncation-mode';

export class ViewModeSettings {
  public modeChange: Subject<boolean> = new Subject<boolean>();

  public toolbarPosition: ToolbarPosition = ToolbarPosition.Top;

  public textTruncation: TruncationMode = TruncationMode.Middle;

  public sideBarCollapse = false;

  public showTooltips = true;

  public searchInHeader = false;

  public isFullScreen = false;

  changeToolbarPosition(position: ToolbarPosition) {
    this.toolbarPosition = position;
    this.raiseModeChange();
  }

  public setToolbarPositionByName(name: string) {
    if (name == null || name == '') {
      return;
    }
    name = name.toLowerCase();
    if (name == 'top') {
      this.changeToolbarPosition(ToolbarPosition.Top);
    } else if (name == 'left') {
      this.changeToolbarPosition(ToolbarPosition.Left);
    } else if (name == 'bottom') {
      this.changeToolbarPosition(ToolbarPosition.Bottom);
    }
  }

  changeTextTruncation(mode: TruncationMode) {
    this.textTruncation = mode;
  }

  public setTextTruncationByName(name: string) {
    if (name == null || name == '') {
      return;
    }
    name = name.toLowerCase();
    if (name == 'start') {
      this.changeTextTruncation(TruncationMode.Start);
    } else if (name == 'middle') {
      this.changeTextTruncation(TruncationMode.Middle);
    } else if (name == 'end') {
      this.changeTextTruncation(TruncationMode.End);
    }
  }

  raiseModeChange() {
    this.modeChange.next(true);
  }
}
